import Repository from "./RepositoryFactoryMain";
const GET = "get";
const CREATE = "create";
const UPDATE = "update";

export default {
  Get(payload) {
    return Repository.post(transformRoute(GET), payload);
  },
  Create(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  Update(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },
};

const transformRoute = (route) => {
  return `/errormanagment/${route}`;
};
